'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _aphrodite = require('aphrodite');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Email component used to get the user's email address
 * - used with account creation and can be a hidden input
 */

var styles = _aphrodite.StyleSheet.create({
	errorMessage: {
		transition: 'all 0.25s ease-in-out'
	}
});

var Email = _react2.default.createClass({
	displayName: 'Email',

	propTypes: {
		type: _react.PropTypes.string.isRequired,
		label: _react.PropTypes.string,
		helpText: _react.PropTypes.string,
		required: _react.PropTypes.bool,
		value: _react.PropTypes.string,
		errorMessage: _react.PropTypes.string,
		changeEmail: _react.PropTypes.func,
		handleFocus: _react.PropTypes.func,
		handleBlur: _react.PropTypes.func
	},

	getDefaultProps: function getDefaultProps() {
		return {
			type: 'email',
			handleFocus: function handleFocus() {},
			handleBlur: function handleBlur() {}
		};
	},
	getInitialState: function getInitialState() {
		return { showIsRequiredError: false };
	},


	/**
  * Handle changing the email
  * Calls parent's handler
  * @param {String} email - the user's email
  */
	handleChangeEmail: function handleChangeEmail(email) {
		this.handleCheckForValue(email);
		this.props.changeEmail(email);
		return email;
	},


	/**
  * Check for an email value
  * If the field is required, we should show that this field needs a value
  * @param {String} email - user's email
  */
	handleCheckForValue: function handleCheckForValue(email) {
		this.setState({ showIsRequiredError: this.props.required && !email });
	},


	/**
  * Call parent's handleFocus
  * @param {String} email - user's email
  */
	handleFocus: function handleFocus(email) {
		this.props.handleFocus(email);
	},


	/**
  * Check for an email value and call parent's handleBlur
  * @param {String} email - user's email
  */
	handleBlur: function handleBlur(email) {
		this.handleCheckForValue(email);
		this.props.handleBlur(email);
	},
	render: function render() {
		var _props = this.props,
		    initialValue = _props.value,
		    errorMessage = _props.errorMessage;

		var errorStyles = {
			height: 0,
			padding: 0
		};
		if (errorMessage) {
			errorStyles = { height: '100%' };
		}

		// define the wrapper classNames, which handle showing error messages
		var wrapperClassNames = (0, _classnames2.default)({
			'vx_has-error-with-message': errorMessage,
			'vx_has-error': !errorMessage && this.state.showIsRequiredError
		});

		// input classNames based on if the input should be hidden
		var emailClassNames = (0, _classnames2.default)({
			hidden: this.props.type === 'hidden',
			'vx_form-control': this.props.type !== 'hidden',
			'vx_form-control_complex': this.props.type !== 'hidden'
		});

		return _react2.default.createElement(
			'div',
			{ className: wrapperClassNames, style: { margin: '10px 0 0', position: 'relative' } },
			_react2.default.createElement(_reactTextInput2.default, {
				type: this.props.type,
				name: 'email',
				id: 'email',
				className: emailClassNames,
				label: this.props.label,
				helpText: this.props.helpText,
				required: this.props.required,
				value: initialValue,
				errorMessage: this.props.errorMessage,
				handleChange: this.handleChangeEmail,
				handleFocus: this.handleFocus,
				handleBlur: this.handleBlur
			}),
			_react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.errorMessage), {
						'vx_form-control-message': errorMessage
					}), style: errorStyles },
				errorMessage
			)
		);
	}
});

exports.default = Email;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/Email.js
// module id = 724
// module chunks = 5